import { FETCH_CARDS, ADD_FILTER, REMOVE_FILTER } from "../types";
import cigarette1 from "../../theme/images/cigarette1.png";
import noCigarette from "../../theme/images/no-cigarette.png";

const initialState = {
	cards: {
		tobacco: [
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 1,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 2,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 3,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 4,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 5,
			},
			{
				img: noCigarette,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: false,
				amount: 0,
				id: 6,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 7,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 8,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 9,
			},
			{
				img: noCigarette,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: false,
				amount: 0,
				id: 10,
			},
		],
		consumables: [
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 11,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 12,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 13,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 14,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 15,
			},
			{
				img: noCigarette,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: false,
				amount: 0,
				id: 16,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 17,
			},
		],
		cigarettes: [
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 18,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 19,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 20,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 21,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 22,
			},
			{
				img: noCigarette,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: false,
				amount: 0,
				id: 23,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 24,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 25,
			},
			{
				img: noCigarette,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: false,
				amount: 0,
				id: 26,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 27,
			},
		],
		accessories: [
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 28,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 29,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 30,
			},
			{
				img: noCigarette,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: false,
				amount: 0,
				id: 31,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 32,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 33,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 34,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 35,
			},
			{
				img: noCigarette,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: false,
				amount: 0,
				id: 36,
			},
			{
				img: cigarette1,
				type: "Тютюн для самокруток",
				name: "Mac Baren Cherry Choice 40 г.",
				price: 180,
				available: true,
				amount: 0,
				id: 37,
			},
		],
	},
	total: 0,
	filters: [],
	currentPage: 1,
};

export const cardReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_CARDS:
			return { ...state, cards: action.payload };

		// case FETCH_ARTICLES:
		// 	return {...state, cards: action.payload}

		// case SET_CURRENT_PAGE:
		// 	return {...state, currentPage: action.payload}

		case ADD_FILTER:
			return { ...state, filters: state.filters.concat(action.payload) };

		case REMOVE_FILTER:
			let copyFilters = [...state.filters];
			copyFilters.splice(action.payload, 1);
			return { ...state, filters: copyFilters };

		default:
			return state;
	}
};
